import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isMobile } from '../../utils/deviceUtils';
import { shouldShowInstallPrompt } from './InstallAppModal';
import InstallAppModal from './InstallAppModal';

interface InstallPromptGateProps {
    children: React.ReactNode;
}

const INSTALL_PROMPT_EXCLUDED_PATH_PREFIXES = ['/recovery', '/registration', '/kyc/identity'];

/**
 * На мобильных при первом заходе показывает модалку с призывом установить приложение.
 * После 3 пропусков модалка не показывается.
 * На исключенных роутингах (например recovery/registration) модалка не показывается.
 */
const InstallPromptGate: React.FC<InstallPromptGateProps> = ({ children }) => {
    const [showModal, setShowModal] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const isExcludedRoute = INSTALL_PROMPT_EXCLUDED_PATH_PREFIXES.some((pathPrefix) =>
            location.pathname.startsWith(pathPrefix),
        );
        if (isExcludedRoute) {
            setShowModal(false);
            return;
        }
        if (isMobile() && shouldShowInstallPrompt() && !isExcludedRoute) {
            setShowModal(true);
        }
    }, [location.pathname]);

    return (
        <>
            {children}
            <InstallAppModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </>
    );
};

export default InstallPromptGate;
